import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import LoginModal from './LoginModal';

/** Показывает форму входа, если silent refresh не удался во время работы в приложении. */
export default function AuthSessionHandler() {
  const {
    sessionExpiredMessage,
    clearSessionExpiredMessage,
    signIn,
    signUp,
  } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (sessionExpiredMessage) setIsOpen(true);
  }, [sessionExpiredMessage]);

  if (!sessionExpiredMessage) return null;

  const handleClose = () => {
    setIsOpen(false);
    clearSessionExpiredMessage();
  };

  const handleLogin = async (email: string, password: string): Promise<boolean> => {
    try {
      await signIn(email, password);
      handleClose();
      return true;
    } catch {
      return false;
    }
  };

  const handleRegister = async (name: string, email: string, password: string) => {
    const result = await signUp(name, email, password);
    handleClose();
    return result;
  };

  return (
    <>
      <div className="fixed left-1/2 top-4 z-[1200] w-[min(92vw,520px)] -translate-x-1/2 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 shadow-lg">
        {sessionExpiredMessage}
      </div>
      <LoginModal
        isOpen={isOpen}
        onClose={handleClose}
        onLogin={handleLogin}
        onRegister={handleRegister}
        redirectPath={window.location.hash.replace(/^#/, '') || '/'}
      />
    </>
  );
}
